'use strict';

// Options for the "Type" combo box in the Create New Features.
module.exports = [
  '-10_signal',
  '-35_signal',
  "3'clip",
  "5'clip",
  "3'UTR",
  "5'UTR",
  'allele',
  'assembly_gap',
  'attenuator',
  'C_region',
  'CAAT_signal',
  'centromere',
  'CDS',
  'conserved',
  'D_segment',
  'D-loop',
  'enhancer',
  'exon',
  'gap',
  'GC_signal',
  'gene',
  'iDNA',
  'intron',
  'J_region',
  'J_segment',
  'LTR',
  'mat_peptide',
  'misc_binding',
  'misc_difference',
  'misc_feature',
  'misc_marker',
  'misc_recomb',
  'misc_RNA',
  'misc_signal',
  'misc_structure',
  'mobile_element',
  'modified_base',
  'mRNA',
  'N_region',
  'ncRNA',
  'old_sequence',
  'operator',
  'operon',
  'oriT',
  'plasmid',
  'polyA_signal',
  'polyA_site',
  'precursor_RNA',
  'prim_transcript',
  'primer',
  'primer_bind',
  'promoter',
  'proprotein',
  'protein',
  'protein_domain',
  'protein_bind',
  'RBS',
  'regulatory',
  'rep_origin',
  'repeat_region',
  'repeat_unit',
  'rRNA',
  's_mutation',
  'S_region',
  'satellite',
  'scRNA',
  'sig_peptide',
  'snoRNA',
  'snRNA',
  'source',
  'start',
  'stem_loop',
  'stop',
  'STS',
  'tag',
  'TATA_signal',
  'telomere',
  'terminator',
  'tmRNA',
  'transit_peptide',
  'transposon',
  'tRNA',
  'V_region',
  'V_segment',
  'variation',
  'unsure'
];



// WEBPACK FOOTER //
// ./src/seq/FeatureTypes.js